export default "__VITE_ASSET__BdcHNZA8__"